import React from 'react';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Button, Typography, COLORS } from '@treelab/panda';

import { IDispatch, IRootState } from '../../../modules/stores';
import { GLYPHS } from '../../../constants/icons';

import { Container, RecordBtnMixin } from './styled';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  isSmallWindow: boolean;
  isTinyWindow: boolean;
}

const BlockControls: React.FC<IProps> = ({
  recordAllIds,
  currentRecordId,
  changeRecord,
  isViewEmpty,
  intl: { formatMessage },
}) => {
  const currentIdIdx = recordAllIds?.findIndex((id: string) => id === currentRecordId) || 0;

  return (
    <Container>
      <Button
        css={RecordBtnMixin}
        buttonType="text"
        onClick={() => changeRecord(-1)}
        colorTheme="grey"
        icon={GLYPHS.ARROW_LEFT}
        iconSize={{ height: 15 }}
        isDisabled={isViewEmpty || currentIdIdx === 0}
        itemSize="small"
      />
      <Typography
        type="caption"
        style={{ color: COLORS.grey, margin: '0 8px', lineHeight: 'normal' }}
      >
        {formatMessage(
          { id: 'controls.records' },
          { index: currentIdIdx + 1, total: recordAllIds?.length || 0 },
        )}
      </Typography>
      <Button
        css={RecordBtnMixin}
        buttonType="text"
        onClick={() => changeRecord(1)}
        colorTheme="grey"
        icon={GLYPHS.ARROW_RIGHT}
        iconSize={{ height: 15 }}
        isDisabled={isViewEmpty || currentIdIdx === recordAllIds?.length - 1}
        itemSize="small"
      />
    </Container>
  );
};

const mapState = ({ core, space }: IRootState) => ({
  recordAllIds: get(core, `viewById[${core.currentViewId}].recordsAllIds`),
  isEditingMode: space.isEditingMode,
  currentRecordId: core.currentRecordId,
  isViewEmpty: core.isViewEmpty,
});

const mapDispatch = ({ core }: IDispatch) => ({
  changeRecord: core.changeRecord,
});

export default compose(
  injectIntl,
  connect(
    mapState,
    // @ts-ignore
    mapDispatch,
  ),
)(BlockControls);
